'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Demê hilbijêre'
};

exports['default'] = locale;